import type { SuspenseProps } from 'react';
import { loadable as _loadable } from 'react-lazily/loadable';
import { Spin } from '../components/ui';

export const loadable = <T extends object>(fn: () => Promise<T>, opts?: Partial<SuspenseProps>) =>
  _loadable(fn, {
    fallback: <Spin position="center" />,
    ...opts,
  });
